var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyhoonAsteriskFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 390,
    viewBox: "0 0 390 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203 5.00049V134.231L236.447 9.40329L251.902 13.5444L218.454 138.375L283.071 26.4548L296.928 34.4548L232.31 146.376L323.693 54.9928L335.007 66.3065L243.624 157.689L355.544 93.0722L363.544 106.929L251.624 171.546L376.455 138.097L380.596 153.552L255.766 187H384.999V203H255.766L380.596 236.448L376.455 251.903L251.624 218.455L363.544 283.072L355.544 296.929L243.625 232.312L335.007 323.694L323.693 335.007L232.311 243.625L296.928 355.545L283.071 363.545L218.454 251.625L251.902 376.456L236.448 380.597L203 255.769V385H187V255.763L153.551 380.596L138.096 376.455L171.544 251.625L106.928 363.544L93.0713 355.544L157.687 243.626L66.3064 335.007L54.9927 323.693L146.374 232.312L34.4546 296.929L26.4546 283.072L138.374 218.455L13.5444 251.903L9.40332 236.449L134.234 203H4.99951V187H134.234L9.40284 153.552L13.5439 138.097L138.374 171.545L26.4546 106.929L34.4546 93.0722L146.375 157.69L54.9924 66.3068L66.3062 54.9931L157.688 146.375L93.0713 34.4555L106.928 26.4555L171.544 138.375L138.096 13.5453L153.551 9.40421L187 134.237V5.00049H203Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyhoonAsteriskFull);
export default __webpack_public_path__ + "static/media/MoneyhoonAsteriskFull.508632ac97c43d202bcd4aabcc68a95d.svg";
export { ForwardRef as ReactComponent };